import { Container, Content } from './styles';

interface PainelProducaoProps {
  title: 'Online' | 'Acessos';
  quantidade: string;
  color: 'green' | 'yellow';
  icon?: string;
}

export const PainelProducao = ({ color, quantidade, title, icon }: PainelProducaoProps) => {
  return (
    <Container color={color}>
      <img src={icon} alt={title} />
      <Content title={title}>
        <p>{title}</p>
        <strong>{quantidade}</strong>
      </Content>
    </Container>
  );
};
